import { render, staticRenderFns } from "./Kurse_extern.vue?vue&type=template&id=7d5a8e9d&scoped=true"
import script from "./Kurse_extern.vue?vue&type=script&lang=js"
export * from "./Kurse_extern.vue?vue&type=script&lang=js"
import style0 from "./Kurse_extern.vue?vue&type=style&index=0&id=7d5a8e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a8e9d",
  null
  
)

export default component.exports